import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceIntro, dependantsExcess } from './shared';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>
          One of our top Bronze offerings, providing great value and added peace of mind, including bonus services like:
        </P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Back, neck and spine</Strong>
          </li>
          <li>
            <Strong>Dental surgery</Strong>
          </li>
          <li>
            <Strong>CPAP machine purchase / hire^^</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    description: (
      <>
        <P>
          One of our top Bronze offerings, providing great value and added peace of mind, including bonus services like:
        </P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Back, neck and spine</Strong>
          </li>
          <li>
            <Strong>Dental surgery</Strong>
          </li>
          <li>
            <Strong>CPAP machine purchase / hire^^</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    disclaimer: (
      <>
        {ambulanceIntro.featureDisclaimer}
        <P>^^Check your Product guide for limits, waiting periods and more information.</P>
      </>
    ),
  },
};
